import { useToggle } from "@netfront/common-library";
import { useToast } from "@netfront/ekardo-content-library";
import { IUser, useDomain, useGetLoggedUser, useLogout } from "@netfront/gelada-identity-library";
import { Avatar, useClickOutside } from "@netfront/ui-library"
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";

export const UserMenu = () => {
  const { push } = useRouter();
  const { getDomain } = useDomain();
  const { handleToastError } = useToast();
  const { isToggled: isMenuOpen, toggle: toggleMenu } = useToggle();
  const menuRef = useRef(null);

  const [user, setUser] = useState<IUser>();

  const { handleGetLoggedUser } = useGetLoggedUser({
    onCompleted: ({ user }) => setUser(user)
  });

  const { handleLogout } = useLogout({
    onCompleted: () => {
      push('/').catch((error) =>
        handleToastError({
          error,
          shouldUseFriendlyErrorMessage: true,
        }),
      );
    },
  });

  useClickOutside(menuRef, () => {
    if (isMenuOpen) {
      toggleMenu();
    }
  });

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isMenuOpen) {
        toggleMenu();
      }
    },
    [isMenuOpen, toggleMenu],
  );

  useEffect(() => {
    handleGetLoggedUser();
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return user ? (
    <div ref={menuRef} className="c-dropdown c-user-menu spotlight-item--9">
      <button aria-expanded={isMenuOpen} aria-controls="user-menu" className="c-dropdown-toggle" type="button" onClick={() => toggleMenu()}>
        <Avatar title={`${user?.firstName} ${user?.lastName}`} />
      </button>

      {isMenuOpen && (
        <ul id="user-menu" className="c-user-menu__dropdown shadow">
          <li className="c-user-menu__item">
            <div className="c-user-menu__header">
              <p className="c-user-menu__title">{user.firstName} {user.lastName}</p>
              <p className="c-user-menu__description">{user.credential.email}</p>
            </div>
          </li>
          <li className="c-user-menu__item">
            <Link href="/user/profile">Profile</Link>
          </li>
          <li className="c-user-menu__item">
            <Link href="/contact">Contact us</Link>
          </li>
          <li className="c-user-menu__item">
            <Link href="/about-us">About us</Link>
          </li>
          <li className="c-user-menu__item">
            <Link href="/team">Team</Link>
          </li>
          <li className="c-user-menu__item">
            <button
              className="c-user-menu__item"
              onClick={() => handleLogout({ domain: getDomain(), path: '/' })}
            >
              Logout
            </button>
          </li>
        </ul>
      )}
    </div>
  ) : null
};